<breadcrumb endText="Subsections"/>
@if (show_delete_subsection_dialog) {
  <div class="fixed inset-0 bg-gray-600 bg-opacity-60 z-30 flex items-center justify-center">
    <div class="bg-white rounded-lg p-4 w-fit max-w-[600px]">
      <div class="flex justify-between items-start mb-3 text-[#4B5563] pb-4 mb-4">
        <div class="rounded-full bg-[#FCEBEB] flex justify-center items-center w-[48px] h-[48px] mr-5">
          <fa-icon class="text-[#A32D2D] text-lg" [icon]="faTrash" />
        </div>
        <div class="mr-10">
          <span class="font-semibold text-lg">Delete subsection?</span><br/>
          This will permanently delete "{{delete_subsection_name}}". This action can't be undone.
        </div>
      </div>
      <div class="flex bg-[#FAEEDA] rounded-[8px] text-[#854F0B] px-5 py-2">
        <fa-icon class="text-lg mr-5" [icon]="faExclamationTriangle" />
        All students currently assigned to this subsection will be unassigned. They'll need to be reassigned to another subsection.
      </div>
      <div class="flex justify-end mt-5">
        <outline-button text="Cancel" (click)="show_delete_subsection_dialog = false; delete_subsection_id = -1" />
        <full-button [faIcon]="faTrash" text="Delete subsection" (click)="confirmDeleteSubsection()" />
      </div>
    </div>
  </div>
}

@if (showCreateSubsection || showEditSubsection) {
  <div class="fixed inset-0 bg-gray-600 bg-opacity-60 z-30 flex items-center justify-center">
    <div class="bg-white rounded-lg p-4 w-fit max-w-[50%]">
      <div class="flex justify-between items-center mb-3 text-[#4B5563] border-b border-[#E3E3E3] pb-4 mb-4">
        <div class="mr-10">
          <span class="font-semibold">Create Subsection</span><br/>
          Add a new subsection to this course
        </div>
        <button (click)="cancelSubsectionDialog()" class="p-1.5 w-10 h-10 rounded-full hover:bg-gray-200 flex items-center justify-center">
          <fa-icon [icon]="faXmark" />
        </button>
      </div>
      <div class="gap-y-2 text-[#4B5563]">
        <div>Name:</div>
        <input [(ngModel)]="create_subsection_info.name" type="text" class="input w-full mb-4" placeholder="e.g. Week 3 discussion" />
        <div>Course:</div>
        <select type="select"
                [(ngModel)]="create_subsection_info.course_id"
                class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 w-full mb-4">
          <option [value]="-1" disabled selected>Select a course</option>
          @for (course of my_courses; track course) {
            <option [value]="course.course_id">
              {{course.name}}
            </option>
          }
        </select>
        <div>Type:</div>
        <select type="select"
                [(ngModel)]="create_subsection_info.type"
                class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 w-full mb-4">
          <option value="null" disabled selected>Select type</option>
          @for (type of subsection_types; track type) {
            <option [value]="type">
              {{type}}
            </option>
          }
        </select>
        <div>Description:</div>
        <textarea [(ngModel)]="create_subsection_info.description" placeholder="What's this subsection about?" class="input w-full mb-4"></textarea>
      </div>
      <div class="flex justify-end mt-3">
        <outline-button text="Cancel" (click)="cancelSubsectionDialog()" />
        @if (edit_subsection_id === -1) {
          <full-button [faIcon]="faPlus" text="Create" (click)="createSubsection()" />
        } @else {
          <full-button (click)="confirmEditSubsection()" text="Save" />
        }
      </div>
    </div>
  </div>
}

<div class="self-stretch self-stretch pl-16 pr-10 pt-14 pb-4 inline-flex flex-col justify-start items-start gap-8 w-full">
  <div class="self-stretch justify-start text-neutral-950 text-3xl font-semibold leading-10">
    Subsections
  </div>
  <div class="self-stretch inline-flex justify-between items-center w-full">
    <div class="w-fit rounded-lg inline-flex justify-end items-center gap-3">
      <div class="w-80 h-12 py-[10px] px-[16px] h-[48px] rounded-lg outline outline-1 outline-offset-[-1px] outline-gray-400/50 inline-flex justify-start items-center gap-3 bg-white">
        <fa-icon [icon]="faMagnifyingGlass" class="text-[#637381]" />
        <input (ngModelChange)="debounceSearch()" class=".placeholder-[#586674] bg-transparent !outline-none flex-grow h-full" placeholder="Search..." [(ngModel)]="searchText"/>
      </div>

      <div class="relative" appClickOutside (clickOutside)="openFilters = false">
        <button (click)="openFilters = true" class="py-[10px] transition px-[16px] h-[48px] rounded-[8px] border border-[#D0D5DD] bg-[#FFF] shadow-xs text-[#344054] text-[14px] flex items-center font-semibold hover:border-[#718293] hover:bg-[#D6DBE0]">
          <svg xmlns="http://www.w3.org/2000/svg" class="mr-[8px]" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Filters
        </button>
        @if (openFilters) {
          <div class="absolute bottom-[-550px] bg-white rounded-md shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)] flex flex-col w-[324px]">
            <div class="flex w-full items-center justify-between px-[24px] pt-[14px]">
              <span class="text-gray-800 text-lg font-bold">
                Filters
              </span>
              <button (click)="resetFilters()" class="text-rutgers-red text-base font-normal lowercase hover:bg-[#FAE6EB] transition rounded-[8px] px-[12px] py-[6px]">
                reset
              </button>
            </div>
            <div class="px-[24px] pt-[26px] flex flex-col">
              <div class="text-gray-800 text-base font-medium">
                Course
              </div>
              <select type="select"
                      [(ngModel)]="course_name"
                      class="block mt-[12px] rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
                <option value="null" disabled selected>Select a course</option>
                @for (course of distinct_course_names; track course) {
                  <option [value]="course">
                    {{course}}
                  </option>
                }
              </select>
              <div class="text-gray-800 text-base font-medium mt-[16px]">
                Type
              </div>
              <select type="select"
                      [(ngModel)]="filter_type"
                      class="block mt-[12px] rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
                <option value="null" disabled selected>Select type</option>
                @for (type of subsection_types; track type) {
                  <option [value]="type">
                    {{type}}
                  </option>
                }
              </select>
              <div class="text-gray-800 text-base font-medium mt-[16px]">
                Date Range
              </div>
              <div class="mt-[14px] rounded-[8px] border border-[#CBD1D7]">
                <interactive-calendar [(startDate)]="filterStartDate" [(endDate)]="filterEndDate" />
              </div>
            </div>
            <div class="px-[24px] py-[16px]">
              <button (click)="applyFilter()" class="text-white bg-rutgers-red font-semibold text-sm px-[12px] py-[6px] rounded-[8px] hover:bg-[#8E0D18] transition">
                Apply Filters
              </button>
            </div>
          </div>
        }
      </div>
      <dot-spinner [isLoading]="isLoading"></dot-spinner>
    </div>

    <div class="flex px-[8px] py-[4px] rounded-[8px] border border-[#D7D7D7] bg-white text-[16px]">
      <button
        (click)="mySubsectionsClick()"
        [ngClass]="!allSubsections?
        'flex w-[152px] h-[35px] px-[12px] py-[9px] justify-center items-center gap-[10px] rounded-[8px] bg-[#FBEBEF] text-base font-medium text-rutgers-red'
        : 'flex w-[152px] h-[35px] px-[12px] py-[9px] justify-center items-center gap-[10px] rounded-[8px] text-base font-medium text-stone-500 hover:bg-gray-200 transition'">
        My Subsections
      </button>
      <button
        (click)="allSubsectionsClick()"
        [ngClass]="allSubsections?
        'flex w-[152px] h-[35px] px-[12px] py-[9px] justify-center items-center gap-[10px] rounded-[8px] bg-[#FBEBEF] text-base font-medium text-rutgers-red'
        : 'flex w-[152px] h-[35px] px-[12px] py-[9px] justify-center items-center gap-[10px] rounded-[8px] text-base font-medium text-stone-500 hover:bg-gray-200 transition'">
        All Subsections
      </button>
    </div>

    <full-button (click)="showCreateSubsection = true" text="Create Subsection" [faIcon]="faPlus" />
  </div>

  <div class="w-full">
    <div class="bg-[#E2E8F0] rounded-md grid grid-cols-6 overflow-hidden h-[64px] w-full">
      <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
        name
      </div>
      <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
        course
      </div>
      <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
        timeframe
      </div>
      <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
        description
      </div>
      <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
        type
      </div>
      <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-xs font-semibold uppercase leading-5">
        actions
      </div>
    </div>
    @if (!isLoading) {
      @for (subsection of my_subsections; track subsection; let i = $index) {
        <div [ngClass]="i % 2 === 0? 'rounded-md grid grid-cols-6 overflow-hidden h-[64px] w-full': 'bg-[#F3F6F9] rounded-md grid grid-cols-6 overflow-hidden h-[64px] w-full'">
          <div class="flex px-[12px] py-[10px] items-center font-normal text-black/90 text-xs leading-5">
            {{subsection.name}}
          </div>
          <div class="flex px-[12px] py-[10px] items-center text-gray-500 text-sm font-medium leading-5">
            {{subsection.course.name}}
          </div>
          <div class="flex px-[12px] py-[10px] items-center font-normal text-black/90 text-xs leading-5">
            <div class="inline-grid grid-cols-[repeat(2,max-content)] gap-x-1">
              <span class="text-gray-500 font-medium">Start: </span> <span>{{subsection.course.start | date: 'short'}}</span>
              <span class="text-gray-500 font-medium">End: </span> <span>{{subsection.course.end | date: 'short'}}</span>
            </div>
          </div>
          <div class="flex px-[12px] py-[10px] items-center font-normal text-black/90 text-xs leading-5">
            {{subsection.description}}
          </div>
          <div class="flex px-[12px] py-[10px] items-center font-normal text-black/90 text-xs leading-5">
            @if (subsection.subsection_type === 'WholeClass') {
              <div class="w-[140px] flex px-[6px] py-[4px] justify-center items-center bg-[#D6E6E7] text-[#52A2A9] rounded-[4px] text-sm font-semibold">
                Whole Class
              </div>
            }
            @if (subsection.subsection_type === 'Manual') {
              <div class="w-[140px] flex px-[6px] py-[4px] justify-center items-center bg-[#FAEBDB] text-[#FFA033] rounded-[4px] text-sm font-semibold">
                Manual
              </div>
            }
          </div>
          <div class="flex gap-[8px] items-center mx-[12px]">
            <button (click)="navigateToSubsectionStudents(subsection.subsection_id, subsection.name)" aria-label="View Students" tooltip="Students" >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z" stroke="#637381" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button aria-label="View Assessments" tooltip="Assessments">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 13H8M16 17H8M10 9H8M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z" stroke="#637381" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button
              (click)="openEditSubsectionDialog(subsection.subsection_id, subsection.name, subsection.course_id, subsection.description, subsection.subsection_type)"
              aria-label="Edit Subsection" tooltip="Edit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 10.0001L14 6.00006M2.5 21.5001L5.88437 21.124C6.29786 21.0781 6.5046 21.0551 6.69785 20.9925C6.86929 20.937 7.03245 20.8586 7.18289 20.7594C7.35245 20.6476 7.49955 20.5005 7.79373 20.2063L21 7.00006C22.1046 5.89549 22.1046 4.10463 21 3.00006C19.8955 1.89549 18.1046 1.89549 17 3.00006L3.79373 16.2063C3.49955 16.5005 3.35246 16.6476 3.24064 16.8172C3.14143 16.9676 3.06301 17.1308 3.00751 17.3022C2.94496 17.4955 2.92198 17.7022 2.87604 18.1157L2.5 21.5001Z" stroke="#637381" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button (click)="show_delete_subsection_dialog = true; delete_subsection_id = subsection.subsection_id; delete_subsection_name = subsection.name" aria-label="Delete Subsection" tooltip="Delete">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#CC0033" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      }
    } @else {
      @for (i of [1, 2, 3]; track i) {
        <div class="bg-gray-100 animate-pulse rounded-md h-[63px] w-full mt-[1px]"></div>
      }
    }
    <full-length-pagination
      [(currentPagination)]="currentPagination"
      perPageText="Rows"
      (paginationService)="handleServiceCall()"
    />
  </div>
</div>
